import { translate } from 'i18n';
import TKeys from 'i18n/translationKey';

export const lookup: LaneLookup = {
  todo: translate(TKeys.Dashboard.todo_label),
  'in-progress': translate(TKeys.Dashboard.inprogress_label),
  complete: translate(TKeys.Dashboard.complete_label),
};
